import { SecurityAppDetectionChains } from "@graylog/enterprise-api";
import { qualifyUrl } from "util/URLUtils";
import EnterpriseApiRoutes from "common/ApiRoutes";
import glFetch from "logic/rest/FetchProvider";
const buildListQuery = (params) => {
  const pairs = [
    ["page", String(params.page)],
    ["per_page", String(params.per_page)]
  ];
  if (params.query) pairs.push(["query", params.query]);
  if (params.sort) pairs.push(["sort", params.sort]);
  if (params.direction) pairs.push(["direction", params.direction]);
  return pairs.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join("&");
};
export const fetchDetectionChains = async (params) => glFetch(
  "GET",
  qualifyUrl(EnterpriseApiRoutes.SecurityEvents.definitions.DetectionChains.list(buildListQuery(params)).url)
);
export const fetchDetectionChain = async (name) => SecurityAppDetectionChains.get(name);
export const enableDetectionChain = async (name) => SecurityAppDetectionChains.enableChain(name);
export const disableDetectionChain = async (name) => SecurityAppDetectionChains.disableChain(name);
export const createDetectionChain = async (payload) => glFetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityEvents.definitions.DetectionChains.create().url), payload);
export const updateDetectionChain = async (id, payload) => glFetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityEvents.definitions.DetectionChains.update(id).url), payload);
export const deleteDetectionChain = async (id) => glFetch("DELETE", qualifyUrl(EnterpriseApiRoutes.SecurityEvents.definitions.DetectionChains.del(id).url));
